import { fork } from 'redux-saga/effects'

import Skus from './modules/skus/sagas'

export default function * root () {
  yield fork(Skus)
}
